import React, { ComponentProps } from 'react';

import LockedNavCog from 'app/developer-v3/components/LockedNavCog';
import ActionsDropdownMenu from 'app/developer-v3/components/ActionsDropdownMenu';

type Props = {
  items: ComponentProps<typeof ActionsDropdownMenu>['items'];
  isNotAdmin: boolean;
};

function ColumnActions({ items, isNotAdmin }: Props) {
  return isNotAdmin ? (
    <LockedNavCog message="Admin access only" />
  ) : (
    <ActionsDropdownMenu items={items} />
  );
}

export default ColumnActions;
